import { useState } from 'react';
import './App.css';
import Card from "./components/card/Card";

function App() {

  const [range, setRange] = useState("50%");


  return (
    <div className="App">
     <Card />
    </div>
  );
}

export default App;
